//permission constant

export enum PERMISSION {
  SUBTYPE_USER = 'subType:user',
  SUBTYPE_MEMBERS = 'subType:members',
  SUBTYPE_MEMBERS_ADMIN = 'subType:members:admin',


};
